import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'phosphor-react';
import { Button, ButtonProps } from '@chakra-ui/react';
import { colors } from '../../../theme/colors';

interface ReturnButtonProps extends ButtonProps {
  label?: string;
  previousPage?: string;
}

export const ReturnButton = ({ previousPage, label, ...props }: ReturnButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (previousPage === '') {
      // Se previousPage for string vazia, vai para a home
      navigate('/');
    } else if (previousPage) {
      // Evita barra dupla se previousPage ja comecar com /
      const path = previousPage.startsWith('/') ? previousPage : `/${previousPage}`;
      navigate(path);
    } else {
      // Se previousPage for undefined, volta no histórico
      navigate(-1);
    }
  };

  return (
    <div className="flex justify-start">
      <Button
        variant="link"
        color="text.secondary"
        onClick={handleClick}
        leftIcon={<ArrowLeft size={32} color={colors.primary} />}
        {...props}
      >
        {label}
      </Button>
    </div>
  );
};
